/*
 * @Author: caiqin.xie
 * @since: 2023-08-14 19:23:26
 * @lastTime: 2023-10-30 15:07:38
 * @LastEditors: huangfuchunmei
 * @message: 服务支持主页-推荐服务组件
 */
import React from "react";
import { useDevice } from "@/hooks";
import styles from "../../index.module.scss";
import { serviceRecommendList } from '@/common/const';
import LazyMedia from "@/components/LazyMedia"
import { IBanner } from "@/common/types";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  banner: IBanner; // 服务支持banner2
}

const ServiceRecommendation = (props:IProps) => {
  const {ctry, words, banner} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
    <section className={`${styles["support-service"]} ${styles["support-section"]}`}>
      <h2>
        {words.support_home_service_title}
        {/* Service recommendation */}
      </h2>
      {/* 服务支持-快速入口 */}
      <div className={styles["service-list"]}>
        {serviceRecommendList && serviceRecommendList.map(item => (
          <div key={item.id} className={styles["service-item"]}>
            {item.type === 'route' && (
              <a href={`/${ctry}${item.path}`}>
                <LazyMedia type="image" src={item.icon} alt={words[item.name]} />
                <p>{words[item.name]}</p>
              </a>
            )}
            {item.type === 'link' && (
              <a href={item.path} target="_blank">
                <LazyMedia type="image" src={item.icon} alt={words[item.name]} />
                <p>{words[item.name]}</p>
              </a>
            )}
          </div>
        ))}
        {/* Warranty Query */}
        {/* Warranty Policy */}
        {/* Spare Parts Price */}
        {/* FAQs */}
      </div>
      
      {banner && (
        <div className={styles["service-more"]}>
          {
            banner[newDevice].extension === '.mp4'
            ? <LazyMedia type="video" loop autoPlay preload="auto" playsInline muted src={banner[newDevice]?.url} LazyClassName="full-wh" className="{styles['service-more-img']}"></LazyMedia>
            : <LazyMedia type="image" src={banner[newDevice]?.url} alt={banner[newDevice]?.alt} LazyClassName="full-wh" className={styles['service-more-img']} />
          }
          <div className={styles['service-more-content']}>
            {banner?.isShowTitle === 1 && (
              <h2>{banner?.name}</h2>
            )}
            <h3 className={styles['service-more-desc']} title={banner?.briefIntroduction}>{banner?.briefIntroduction}</h3>
            {
              banner && banner.url && (
                <button className={styles["service-more-btn"]}>
                  <a href={banner?.url} target="_blank">{words.common_learn_more}</a>
                  {/* Learn More */}
                </button>
              )
            }
          </div>
        </div>
      )}
      
    </section>
  )
}
export default ServiceRecommendation
